<template>
	<div>
		<div style="background-color:#F2F2F2 ; color: #E8410B;margin-bottom: 20px; text-align: center;">严守公司经营道德红线:
			1.严禁飞单2.严禁做假资料3.严禁私自留存客户信息(征信报告、身份证复印件、客户名单)一经发现， 严肃处理并且保留追责权利!</div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 450px" class="yl-flex flex_between">
				<Input placeholder="搜索客户姓名/电话/案情描述/备注" v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="getList">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			</div>
			<div style="width: 200px">
				<span style="color: #54A1F3; margin-right: 10px;cursor: pointer;">批量加入公共池</span>
				<Button class="ivu-btn-circle" @click="addClue" type="primary">添加客户</Button>
			</div>
			
		</div>
		<div class="multiple">
			<div class="child-div">时间维度</div>
			<RadioGroup v-model="timeDimension" @on-change="timePeriod='0'">
				<Radio label="1"><span>未跟进时间</span></Radio>
				<Radio label="2"><span>申请时间</span></Radio>
				<Radio label="3"><span>预约上门时间</span></Radio>
				<Radio label="4"><span>实际上门时间</span></Radio>
				<Radio label="5"><span>最新跟进时间</span></Radio>
				<Radio label="6"><span>下次回访时间</span></Radio>
				<Radio label="7"><span>线索分发时间</span></Radio>
			</RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<div v-if="timeDimension == 1">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="3"><span>3天未跟进</span></Radio>
					<Radio label="7"><span>7天未跟进</span></Radio>
					<Radio label="14"><span>14天未跟进</span></Radio>
					<Radio label="30"><span>30天未跟进</span></Radio>
					<Radio label="60"><span>60天未跟进</span></Radio>
				</div>
				<div v-else>
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
				</div>
			</RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">通话标签</div>
			<CheckboxGroup v-model="call_tag">
				<Checkbox label="1"><span>不限</span></Checkbox>
				<Checkbox label="2"><span>关机</span></Checkbox>
				<Checkbox label="3"><span>停机</span></Checkbox>
				<Checkbox label="4"><span>无人接听</span></Checkbox>
				<Checkbox label="5"><span>需回拨</span></Checkbox>
				<Checkbox label="6"><span>空号</span></Checkbox>
				<Checkbox label="7"><span>忙线中</span></Checkbox>
				<Checkbox label="8"><span>开口挂</span></Checkbox>
				<Checkbox label="9"><span>挂断</span></Checkbox>
			</CheckboxGroup>
		</div>
		
		<div class="multiple" style="color: #000000;">
			<span style="font-weight: bold; color: #000000;">提示：</span>
			<span>
				您当前有
				<span class="hong">2位</span>
				客户即将被回收，
				<span class="hong">2位</span>
				客户未处理，
				<span class="lan">5位</span>
				客户超过5天未跟进，
				<span class="lan">11位</span>
				客户超过3天未跟进，
				<span class="lan">2位</span>
				客户超过1天未跟进，其中超过1天未跟进的3星以上客户有
				<span class="hong">5位</span>
				。请注意及时跟进
			</span>
			<span style="color: #277dd3; font-weight: bold; margin-left: 20px; font-size: 15px; cursor: pointer;">刷新</span>
		</div>

		<div class="multiple" style="width: 100%" v-if="menuName == 'contract_management' || menuName == 'contract'">
			<Table :columns="columns" :data="datas" size="small" ref="table"  @on-row-click="rowClick">
				<template slot-scope="{ row }" slot="name">
					<div style="display: flex; align-items: center;">
						<div v-if="row.name.type == 'ge' " style="width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%;">个</div>
						<div v-if="row.name.type == 'qi' " style="width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%;">企</div>
						<div style="display: flex;flex-direction: column; align-items: center;">
							<span>{{row.name.name}}</span>
							<span>{{row.name.phone}}</span>
						</div>
					</div>
				</template>
			
			
				<template slot-scope="{ row }" slot="operation">
					<div style="display: flex; justify-content: space-between; align-items: center; width: 100%; flex-wrap: wrap;">
						<div style="color: #63B3E6; cursor: pointer; width: 50%; margin: 5px 0;">编辑</div>
						<div style="color: #63B3E6; cursor: pointer;width: 50%;margin: 5px 0;">进件</div>
						<div style="color: #63B3E6; cursor: pointer;width: 50%;margin: 5px 0;">查看</div>
						<div style="color: #F81C1E; cursor: pointer;width: 50%;margin: 5px 0;">作废</div>
					</div>
				</template>
			</Table>
		</div>
		<div class="pager" v-if="menuName == 'contract_management' || menuName == 'contract'">
			<Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator />
		</div>
		
		<!-- 进件管理表格 -->
		<div class="multiple" style="width: 100%" v-if="menuName == 'into_a_management' || menuName == 'into_a'">
			<Table :columns="into_columns" :data="into_datas" size="small" ref="table" >
				<template slot-scope="{ row }" slot="name">
					<div style="display: flex; align-items: center;">
						<div v-if="row.name.type == 'ge' " style="width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%;">个</div>
						<div v-if="row.name.type == 'qi' " style="width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%;">企</div>
						<div style="display: flex;flex-direction: column; align-items: center;">
							<span>{{row.name.name}}</span>
							<span>{{row.name.phone}}</span>
						</div>
					</div>
				</template>
			
			
				<template slot-scope="{ row }" slot="operation">
					<div style="display: flex;   align-items: center; width: 100%; flex-wrap: wrap;">
						<div style="color: #63B3E6; cursor: pointer;width: 73%;margin: 5px 0; ">进件管理</div>
						<div style="color: #63B3E6; cursor: pointer;width: 50%;margin: 5px 0;">查看</div>
						<div style="color: #F81C1E; cursor: pointer;width: 50%;margin: 5px 0;">作废</div>
					</div>
				</template>
			</Table>
		</div>
		<div class="pager" v-if="menuName == 'into_a_management' || menuName == 'into_a'">
			<Page :total="countTwo" :page-size="20" :current="pageTwo" @on-change="changePageTwo" size="small" show-elevator />
		</div>
	</div>
</template>
<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getClueList,
		clueGiveOut,
		toBuyBySea
	} from '@/api/client'
	import {
		getUserList
	} from '@/api/user'
	import {
		getCategory
	} from '@/api/api'
	export default {
		name: "CustomClue",
		props: {
			menuName: {
				type: String
			}
		},
		data() {
			return {
				countTwo:0,
				pageTwo:1,
				count: 0,
				page: 1,
				name: '',
				timeDimension: 0,
				timePeriod: 0,
				call_tag: [],
				userList: [],
				giveOutUid: 0,
				is_add_wechat: [],
				timePeriodDate: [],
				datas: [{
					follow_name: '张磊在',
					name: {
						name: '邓忠兰',
						phone: '13036552665',
						type: 'ge'
					},
					sex: '男',
					media: '今日头条',
					need_limit: '5万',
					level: '1星',
					in_line_of_time: '2020-10-19',
					follow_time: '2020-10-19',
					rate:'5%',
					sincerity_gold:'2000',
					sincerity_gold_state:'已退',
					into_a_number:'2',
					contract_number:'154654564',
					submit_state: '进行中',
				},
				{
					follow_name: '张磊在',
					name: {
						name: '邓忠兰',
						phone: '13036552665',
						type: 'qi'
					},
					sex: '男',
					media: '今日头条',
					need_limit: '5万',
					level: '1星',
					in_line_of_time: '2020-10-19',
					follow_time: '2020-10-19',
					rate:'6%',
					sincerity_gold:'5000',
					sincerity_gold_state:'已交',
					into_a_number:'3',
					contract_number:'1546545864',
					submit_state: '已批款',
				}],
				columns: [
					{
							type: 'selection',
							width: 60,
							align: 'center'
						},
					{
						"title": "跟进人",
						"key": "follow_name",
						"width": 60,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						"title": "客户",
						"slot": "name",
						"width": 100,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						"title": "性别",
						"key": "sex",
						"width": 30,
					},
					
					{
						"title": "媒体代码",
						"key": "media",
						"width": 80,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						"title": "需求额度",
						"key": "need_limit",
						"width": 70,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					
					
					{
						"title": "星级",
						"key": "level",
						"width": 60,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						"title": "进线时间",
						"key": "in_line_of_time",
						"width": 100,
						"sortable": true
					},
					{
						"title": "签约时间",
						"key": "follow_time",
						"width": 100,
						"sortable": true
					},
					{
						"title": "费率",
						"key": "rate",
						"width":30,
					},
					{
						"title": "诚意金",
						"key": "sincerity_gold",
						"width": 50
					},
					{
						"title": "诚意金状态",
						"key": "sincerity_gold_state",
						"width": 60
					},
					{
						"title": "进件笔数",
						"key": "into_a_number",
						"width": 50
					},
					{
						"title": "合同编号",
						"key": "contract_number",
						"width": 80
					},
					{
						"title": "签约状态",
						"key": "submit_state",
						"width": 80,
					},
					{
						"title": "操作",
						"slot": "operation",
						"width": 80,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					}
				],
			
			  into_columns:[
					{
							type: 'selection',
							width: 60,
							align: 'center'
						},
					{
						"title": "跟进人",
						"key": "follow_name",
						"width": 60,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						"title": "客户",
						"slot": "name",
						"width": 100,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						"title": "性别",
						"key": "sex",
						"width": 30,
					},
					
					{
						"title": "媒体代码",
						"key": "media",
						"width": 80,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						"title": "需求额度",
						"key": "need_limit",
						"width": 70,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					
					
					{
						"title": "星级",
						"key": "level",
						"width": 60,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						"title": "进件日期",
						"key": "in_line_of_time",
						"width": 100,
						"sortable": true
					},
					{
						"title": "渠道名称",
						"key": "channel_name",
						"width": 80,
					},
					{
						"title": "进件产品",
						"key": "into_the_product",
						"width": 80,
					},
					{
						"title": "进件额度",
						"key": "in_a_line",
						"width": 80,
					},
					{
						"title": "费率",
						"key": "rate",
						"width":30,
					},
					
					
					
					{
						"title": "资方对接人",
						"key": "management_contact_person",
						"width": 80
					},
					{
						"title": "做单人",
						"key": "do_a_single",
						"width": 80
					},
					{
						"title": "进件状态",
						"key": "into_a_state",
						"width": 80,
					},
					{
						"title": "操作",
						"slot": "operation",
						"width": 80,
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					}
				],
			
			  into_datas: [{
			  	follow_name: '张磊在',
			  	name: {
			  		name: '邓忠兰',
			  		phone: '13036552665',
			  		type: 'ge'
			  	},
			  	sex: '男',
			  	media: '今日头条',
			  	need_limit: '5万',
			  	level: '1星',
			  	in_line_of_time: '2020-10-19',
			  	rate:'5%',
			  	channel_name:'平安银行',
			  	into_the_product:'新一贷月供房',
			  	in_a_line:'200000',
			  	submit_state: '已批款',
			  	management_contact_person:'王经理',
			  	do_a_single:'张磊在',
			  	into_a_state:'待签约',
			  },
			  {
			  	follow_name: '张磊在',
			  	name: {
			  		name: '邓忠兰',
			  		phone: '13036552665',
			  		type: 'qi'
			  	},
			  	sex: '男',
			  	media: '今日头条',
			  	need_limit: '5万',
			  	level: '1星',
			  	in_line_of_time: '2020-10-19',
			  	rate:'6%',
					channel_name:'平安银行',
				  into_the_product:'新一贷月供房',
					in_a_line:'200000',
			  	submit_state: '已批款',
					management_contact_person:'王经理',
					do_a_single:'张磊在',
					into_a_state:'待签约'
			  }],
			}
		},
		computed: {
			...mapGetters(['token']),
		},
		mounted: function() {},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			rowClick() {
						this.$router.push({
						    name: 'editClue',
						})
					},
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			loadData() {
				let that = this;
				that.initSearch();
				var data = {
					parent_id: 0,
					type: 4
				};
				getCategory(data).then((res) => {
					var res = res.data;
					if (res.code == 1) {
						that.categoryList = res.data.list;
					}
				})
				var data = {
					token: that.token
				};
				getUserList(data).then((res) => {
					var res = res.data;
					if (res.code == 1) {
						that.userList = res.data.list;
					}
				})
			},
			initSearch() {
				this.name = '';
				this.timeDimension = 0
				this.timePeriod = 0;
				this.status = [];
				this.isComment = 0;
				this.category = [];
				this.is_offer = [];
				this.is_offer = [];
				this.is_add_wechat = [];
				this.clueType = [];
				this.clientType = [];
				this.timePeriodDate = [];
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changePageTwo(e) {
				this.pageTwo = e;
			},
			getList() {
				let that = this;
				var data = this.$data;
				data.menu = this.menuName;
				data.token = this.token;
				data.page = this.page;
				getClueList(data).then((res) => {
					var res = res.data;
					if (res.code != 0) {
						that.$Message.error(res.msg);
						if (res.code == -2) {
							that.handleLogOut();
							that.$router.push({
								name: 'login'
							})
						}
						return;
					}
					that.data = res.data;
					that.count = res.count;
				})
			},
			addClue() {
				this.$router.push({
				    name: 'editClue',
				})
			},
			edit(e) {
				let id = e.currentTarget.dataset.id;
				this.$router.push({
					name: 'editClue',
					query: {
						id: id
					}
				})
			},
			toBuy(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认转入吗？',
					onOk: async () => {
						let data = {
							id: id,
							token: that.token
						}
						that.throttle(function() {
							toBuyBySea(data).then((res) => {
								var res = res.data;
								if (res.code != 1) {
									that.$Message.error(res.msg);
									return;
								}
								that.$Message.success(res.msg);
								that.getList();
							})
						}, 2000);
					}
				})
			},
			giveOut() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(function() {
					clueGiveOut(data).then((res) => {
						var res = res.data;
						if (res.code != 1) {
							that.$Message.error(res.msg);
							return;
						}
						that.$Message.success(res.msg);
						that.getList();
					})
				}, 2000);
			}
		}
	}
</script>
<style lang="less">
	.hong {
		color: #F56171;
		font-weight: bold;
		cursor: pointer;
	}

	.lan {
		color: #124386;
		font-weight: bold;
		cursor: pointer;
	}

	.sousuo {
		width: 100%;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}
</style>
